import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center no-wrap" }

import { TableColumn } from "src/util/types/components/sfxTable"
import { computed, PropType, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableTh',
  props: {
  columns: {
    type: Array as PropType<Array<TableColumn>>,
    required: true,
  },

  visibleColumns: {
    type: Array as PropType<Array<string>>,
    required: true,
  },

  currentColumn: {
    type: Object as PropType<TableColumn>,
    required: true,
  },

  nonSwitchableColumns: {
    type: Array as PropType<Array<string>>,
  },

  disableDropdown: {
    type: Boolean,
  },

  currentSearchColumn: {
    type: Object as PropType<TableColumn>,
  },

  switched: {
    type: Boolean,
  },

  currentSearchValue: {
    type: String,
  },
},
  emits: ["update:columns", "update:visibleColumns", "search"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const { t } = useI18n()

const col = computed(() => props.currentColumn)
const colName = computed(() => col.value.label)

const modelColumns = computed<Array<TableColumn>>({
  get() {
    return props.columns
  },

  set(value) {
    return emit("update:columns", value)
  },
})

const menuColumns = computed(() => {
  let columns = modelColumns.value.filter((col) => !props.nonSwitchableColumns?.includes(col.name))

  if (searchInput.value) {
    columns = columns.filter((i) => i.label.toLowerCase().includes(searchInput.value.toLowerCase()))
  }

  return columns.sort((a, b) => a.label.localeCompare(b.label))
})

const modelVisibleColumns = computed<Array<string>>({
  get() {
    return props.visibleColumns
  },

  set(value) {
    return emit("update:visibleColumns", value)
  },
})

const searchInput = ref("")
const searchInColumnInput = ref<string | null>(props.currentSearchValue || "")
const searchLabel = t("sfxTable.menu_search")
const noResultsLabel = t("sfxTable.menu_none")
const searchInColumnLabel = computed(() =>
  t("sfxTable.menu_search_column", { column: colName.value })
)
const searchInColumn = ref<TableColumn | null>(null)
const columnClass = computed(() => {
  return { "highlight-th": props.switched }
})

//endregion

//region Functions

async function updateCol(newCol: TableColumn) {
  if (newCol.name === col.value.name) return

  const visCols = modelVisibleColumns.value

  const oldValIndex = visCols.indexOf(col.value.name)
  const newValIndex = visCols.indexOf(newCol.name)

  if (newValIndex === -1) {
    visCols[oldValIndex] = newCol.name
  } else {
    const temp = visCols[oldValIndex]
    visCols[oldValIndex] = visCols[newValIndex]
    visCols[newValIndex] = temp
  }
}

function searchValuesInColumn(column: TableColumn) {
  searchInColumn.value = column
}

function blurSearchInColumn() {
  if (!searchInColumnInput.value) {
    searchInColumn.value = null
    emit("search")
  }
}

//endregion

//region Setup Code

watch(
  () => searchInColumnInput.value,
  (val) => {
    if (val != null) {
      emit("search", searchInColumn.value, val)
    }
  }
)

watch(
  () => props.currentSearchColumn,
  (searchCol) => {
    if (searchCol === null || searchCol?.name !== col.value?.name) {
      searchInColumnInput.value = null
      searchInColumn.value = null
    } else {
      searchInColumn.value = searchCol
    }
  },
  { immediate: true }
)

watch(
  () => props.currentSearchValue,
  (searchValue) => {
    if (
      searchValue &&
      searchInColumnInput.value == null &&
      col.value?.name === props.currentSearchColumn?.name
    )
      searchInColumnInput.value = searchValue
  }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_th = _resolveComponent("q-th")!

  return (_openBlock(), _createBlock(_component_q_th, { class: "sfx-table__th" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "sfx-table__th-dropdown",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _createVNode(_Transition, {
            duration: 100,
            mode: "out-in",
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut"
          }, {
            default: _withCtx(() => [
              (searchInColumn.value)
                ? (_openBlock(), _createBlock(_component_q_input, {
                    key: 0,
                    ref: "searchInputRef",
                    borderless: "",
                    autofocus: "",
                    dense: "",
                    label: searchInColumnLabel.value,
                    class: "sfx-table__th-menu-search",
                    onBlur: blurSearchInColumn,
                    modelValue: searchInColumnInput.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInColumnInput).value = $event)),
                    debounce: "500"
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: "magnifying-glass" })
                    ]),
                    _: 1
                  }, 8, ["label", "modelValue"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (col.value.switchable)
                      ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                          key: 0,
                          flat: "",
                          unelevated: "",
                          square: "",
                          "no-caps": "",
                          label: colName.value,
                          split: "",
                          align: "left",
                          "text-color": "fun-label-and-icon",
                          "content-class": "sfx-table__th-menu",
                          "menu-fit": "",
                          class: _normalizeClass(columnClass.value),
                          "disable-dropdown": props.disableDropdown,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (searchValuesInColumn(col.value)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_list, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_input, {
                                      modelValue: searchInput.value,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
                                      borderless: "",
                                      dense: "",
                                      label: _unref(searchLabel),
                                      class: "sfx-table__th-menu-search full-width"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "magnifying-glass" })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "label"])
                                  ]),
                                  _: 1
                                }),
                                (menuColumns.value.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(menuColumns.value, (col) => {
                                      return (_openBlock(), _createBlock(_component_q_item, {
                                        key: col.name,
                                        class: _normalizeClass([{
                          'sfx-table__th-selected': modelVisibleColumns.value.includes(col.name),
                        }, "items-center sfx-table__th-text"]),
                                        clickable: "",
                                        onClick: ($event: any) => (updateCol(col))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(col.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"]))
                                    }), 128))
                                  : (_openBlock(), _createBlock(_component_q_item, {
                                      key: 1,
                                      class: "items-center sfx-table__th-text text-italic"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(noResultsLabel)), 1)
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["label", "class", "disable-dropdown"]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "sfx-table__th-text full-width ellipsis cursor-pointer",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (searchValuesInColumn(col.value)))
                        }, _toDisplayString(colName.value), 1))
                  ], 64))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})